export const loginPath = '/auth';
export const resetPath = `${loginPath}/reset`;
